const serviceBase = '/service/discovery'
const endpoints = {
  get_family: { url: `${serviceBase}/wicf/family` },
  get_miniTree: {
    url: `${serviceBase}/allaboutme/getFamily?generations=2&includeLocations=false`,
  },
}

export default endpoints
